import { create } from "zustand";
import { Platform } from "react-native";
import NetInfo, { NetInfoState } from "@react-native-community/netinfo";

interface NetworkState {
  isOnline: boolean;
  setIsOnline: (bool: boolean) => void;
}

export const useNetworkStore = create<NetworkState>((set) => ({
  isOnline: true,
  setIsOnline: (bool: boolean) => set({ isOnline: bool }),
}));

const updateNetworkState = (netInfoState: NetInfoState) => {
  const isOnline = netInfoState.isInternetReachable ?? true;
  useNetworkStore.getState().setIsOnline(isOnline);

  console.log("Network state changed:", {
    isOnline,
    type: netInfoState.type,
    isConnected: netInfoState.isConnected,
    isInternetReachable: netInfoState.isInternetReachable,
    details: netInfoState.details,
  });
};

let unsubscribe: (() => void) | null = null;

export const networkReachability = {
  initialize: () => {
    if (Platform.OS === "web") {
      return;
    }

    unsubscribe = NetInfo.addEventListener(updateNetworkState);

    NetInfo.fetch().then(updateNetworkState);
  },

  cleanup: () => {
    if (unsubscribe) {
      unsubscribe();
      unsubscribe = null;
    }
  },
};

export function useIsOnline() {
  return useNetworkStore((state) => state.isOnline);
}
